import React from 'react';
import FilterIcon from '../../../assets/icons/FilterIcon';
import styles from '../../../styles/usageRights.module.css';

function FilterLabel() {
  return (
    <div className={styles.filterLabel}>
      <FilterIcon /> Filters
    </div>
  );
}

export default FilterLabel;
